import React from "react";

import { IButtonProps, Tooltip } from "@amphore-dev/amphore-lib";

import { requiredPlanHint, usePlanGate } from "@/hooks/usePlanGate";

import { TPlanGateKey } from "@/types/TSubscription";

interface IPlanGateProps {
	/** The limit or feature the button spends. */
	on: TPlanGateKey;
	/** One Button. Locked, it gets the lock picto and opens the upgrade modal. */
	children: React.ReactElement<IButtonProps>;
}

/**
 * Wraps a button that the plan may not allow. Off-plan the button stays
 * active — a grey button says nothing — but locks: picto, tooltip, and
 * its click opens the upgrade modal instead of doing the thing.
 */
export const PlanGate: React.FC<IPlanGateProps> = ({ on, children }) => {
	const gate = usePlanGate(on);

	if (!gate.locked) return children;

	const { title, ...locked } = gate.button(children.props);

	return (
		<Tooltip content={title ?? requiredPlanHint(gate.requiredPlan)}>
			{React.cloneElement(children, locked)}
		</Tooltip>
	);
};
